import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import IRecycleBinItem from 'interfaces/IRecycleBinItem';
import { fetchRecycleBinItems, forceDeleteRecycleBinItems, restoreRecycleBinItems, restoreRecycleBinItemsInRoot } from 'store/reducers/recycleBinCreator';

interface RecycleBinState {
  items: IRecycleBinItem[];
  isLoading: boolean;
  isDeleting: boolean;
  isRestoring: boolean;
  error: string;
}

const initialState: RecycleBinState = {
  items: [],
  isLoading: false,
  isDeleting: false,
  isRestoring: false,
  error: '',
};

export const recycleBinSlice = createSlice({
  name: 'recycleBin',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRecycleBinItems.pending, (state) => {
      state.isLoading = true;
      state.error = '';
      state.items = [];
    });
    builder.addCase(
      fetchRecycleBinItems.fulfilled,
      (state, action: PayloadAction<IRecycleBinItem[]>) => {
        state.items = action.payload;
        state.isLoading = false;
        state.error = '';
      }
    );
    builder.addCase(fetchRecycleBinItems.rejected, (state, action: any) => {
      state.isLoading = false;
      state.error = action.payload;
      state.items = [];
    });

    builder.addCase(forceDeleteRecycleBinItems.pending, (state) => {
      state.isDeleting = true;
      state.error = '';
    });
    builder.addCase(forceDeleteRecycleBinItems.fulfilled, (state) => {
      state.isDeleting = false;
      state.error = '';
    });
    builder.addCase(forceDeleteRecycleBinItems.rejected, (state, action: any) => {
      state.isDeleting = false;
      state.error = action.payload;
    });

    builder.addCase(restoreRecycleBinItems.pending, (state) => {
      state.isRestoring = true;
      state.error = '';
    });
    builder.addCase(restoreRecycleBinItems.fulfilled, (state) => {
      state.isRestoring = false;
      state.error = '';
    });
    builder.addCase(restoreRecycleBinItems.rejected, (state, action: any) => {
      state.isRestoring = false;
      state.error = action.payload;
    });

    builder.addCase(restoreRecycleBinItemsInRoot.pending, (state) => {
      state.isRestoring = true;
      state.error = '';
    });
    builder.addCase(restoreRecycleBinItemsInRoot.fulfilled, (state) => {
      state.isRestoring = false;
      state.error = '';
    });
    builder.addCase(restoreRecycleBinItemsInRoot.rejected, (state, action: any) => {
      state.isRestoring = false;
      state.error = action.payload;
    });
  },
  reducers: {
    setRecycleBinItems(state, action: PayloadAction<IRecycleBinItem[]>) {
      state.items = action.payload;
    },
    clearRecycleBin(state) {
      state.items = [];
      state.isLoading = false;
      state.isDeleting = false;
      state.isRestoring = false;
      state.error = '';
    },
  },
});

const recycleBinReducer = recycleBinSlice.reducer;

export const { setRecycleBinItems, clearRecycleBin } = recycleBinSlice.actions;

export default recycleBinReducer;
